function sendToTagManager(action, label) {
    // log('sendToTagManager', [action, label]);
    // bps4.sendToTagManager(action, label);
}

function trackAnalyticsEvent(category, action, label) {
    log('trackAnalyticsEvent', [category, action, label]);
    bps4.trackAnalyticsEvent(category, action, label);
}

function trackAnalyticsProducts(urlProduct, callback) {
    log('trackAnalyticsProducts > urlProduct', urlProduct);

    var trackAnalyticsProductsObj = {};
    trackAnalyticsProductsObj["urlProduct"] = urlProduct;
    trackAnalyticsProductsObj["callback"] = callback != null ? callback : function(response) {
        log('trackAnalyticsProducts > response', response);
    };
    log('trackAnalyticsProducts > trackAnalyticsProductsObj', trackAnalyticsProductsObj);
    bps4.trackAnalyticsProducts(trackAnalyticsProductsObj);
}